import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { WeekView } from '@devexpress/dx-react-scheduler-material-ui';
import { useTranslation } from 'react-i18next';
import useWorkScheduleCalendarContext from 'components/AddWorkSchedule/WorkScheduleCalendar/context/useWorkScheduleCalendarContext';
import getDayValues from 'components/SchedulePreviewCalendar/libComponents/DayScaleCellComponent/getDayValues';
import { minDaysInIrregularSchedule } from 'components/AddWorkSchedule/WorkScheduleCalendar/consts';
import { daysInWeek } from 'helpers/timeConsts';
import getWorkScheduleHours from './getWorkScheduleHours';
import DayScaleCloseIcon from './DayScaleCloseIcon/DayScaleCloseIcon';

export default function DayScaleCellComponent({
  startDate,
}: WeekView.DayScaleCellProps) {
  const { t } = useTranslation();
  const { workSchedules, schedule } =
    useWorkScheduleCalendarContext();
  const { day, dayOfWeek, dayWithWeekOffset } = getDayValues({
    startDate,
    isRegularWeek: schedule.regular,
  });
  const isLastDay = dayWithWeekOffset === schedule.numberOfDays;
  const shouldDisplayCloseIconForIrregular =
    isLastDay &&
    !schedule.regular &&
    dayWithWeekOffset > minDaysInIrregularSchedule;
  const shouldDisplayCloseIconForRegular =
    isLastDay && schedule.regular && dayWithWeekOffset > daysInWeek;

  const workScheduleHours = getWorkScheduleHours({
    workSchedules,
    day: dayWithWeekOffset,
  });

  return (
    <Box
      component="td"
      sx={{
        borderRight: '0.1rem solid',
        borderColor: 'border.main',
      }}
    >
      <Stack alignItems="center" px={1} py={2} position="relative">
        {(shouldDisplayCloseIconForIrregular ||
          shouldDisplayCloseIconForRegular) && (
          <DayScaleCloseIcon startDate={startDate} />
        )}
        <Typography
          variant="h6"
          color="text.primary"
          sx={{ userSelect: 'none' }}
        >
          {schedule.regular && dayOfWeek
            ? t(dayOfWeek.abbreviation)
            : t('label.day', { day })}
        </Typography>
        <Box mt={1}>
          {workScheduleHours ? (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ userSelect: 'none' }}
            >
              {workScheduleHours.timeFrom.hours}
              <sup>{workScheduleHours.timeFrom.minutes}</sup>&nbsp;-&nbsp;
              {workScheduleHours.timeTo.hours}
              <sup>{workScheduleHours.timeTo.minutes}</sup>
            </Typography>
          ) : (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ userSelect: 'none' }}
            >
              {t('project_tracking.non_working')}
            </Typography>
          )}
        </Box>
      </Stack>
    </Box>
  );
}
